<template>
    <div>
        <b-table
        :data="cart.items.length ? cart.items : []"
        :loading="loadingCart"
        :narrowed="true"
        :striped="false"
        :bordered="false"
        :mobile-cards="false"
        >
            <template slot-scope="props">
                <b-table-column style="justify-content: center;" field="image" label="" width="100px">
                    <img class="image" :src="props.row.image" alt="item-image">
                </b-table-column>
                <b-table-column field="data" label="">
                    <p><strong>{{ props.row.productTitle }}</strong></p>
                    <p><span v-for=" val in props.row.valueNames" :key="val">{{val}} -</span ></p>   
                    <p><span class="has-text-success">{{props.row.currencySymbol}}{{ props.row.unitPrice }}</span> x {{props.row.quantity}}</p>
                </b-table-column>
                <b-table-column style="justify-content: center;" field="presio" label="">
                    <p class=" tag is-success">{{props.row.currencySymbol}}{{props.row.total}}</p>
                </b-table-column>
                <b-table-column style="justify-content: center;" field="delete" label="">
                    <a 
                    class="has-text-danger"
                    @click="deleteCartItem(props.row.id)" >
                        <b-icon
                        icon="trash">
                        </b-icon>
                    </a>
                </b-table-column>
            </template>

            <template slot="empty">
                <section class="section">
                    <div class="content has-text-grey has-text-centered">
                        <p>
                            <img style="max-width:250px;" :src="noDataIll" alt="no-data">
                        </p>
                        <p>Todavia no agregaste nada!.</p>
                    </div>
                </section>
            </template>
        </b-table>

        <div class="has-text-centered m-t-20">
            <b-button
            class="is-custom"
            rounded
            v-if="cart.items.length"
            @click="orderDetailModal=false;orderDetailModal=true">
                Terminar pedido
            </b-button>
        </div>


        <OrderData
        :orderDetailModal="orderDetailModal"
        :userProfile="userProfile"
        :userEmail="userEmail"
        @modalChange="catchModalChange"
        @savedOrder="createOrder"
        />

    </div>
   
</template>

<script>
import { deleteHandler } from '../../../../services/http'
import OrderData from './OrderData.vue'
export default {
    components:{
        OrderData
    },
    props:{
        loadingCart:{
            type:Boolean,
            default:false
        },
        cart:{
            type:Object,
            default: new Object({})
        },
        userProfile:{
            type:Object,
            default: new Object({})
        },
        cartItemDetailUrl:{
            type:String,
            default:""
        },
        noDataIll:{
            type:String,
            default:""
        },
        userEmail:{
            type:String,
            default:""
        }
    },
    data(){
        return{
            orderDetailModal:false,
        }
    },
    methods:{
        async deleteCartItem(id){
            var error = {
                resource:'toast',
                text:'No se pudo remover el item, intenta de nuevo mas tarde'
            }
            var success = {
                resource:'toast',
                text:'Item eliminado con exito'
            }
            var url = this.cartItemDetailUrl.replace('0000', id)
            var response = await deleteHandler(url, {error, success})
            this.$emit("removeCartItem")
        },
        catchModalChange(val){
            this.orderDetailModal = val
        },
        createOrder(order){
            this.$emit("savedOrder", order)
        }
    },
    
}
</script>

<style lang="scss" scoped>

.item-card{
    border-radius:10px;
    border: var(--primary) 1px solid;
    border-left: var(--primary) 10px solid;
    padding-bottom: 5px;
}

.image{
    width:90px;
}

.is-custom{
    background:var(--primary);
    color:var(--text-color);
}

</style>